import React from 'react';
import {
  DefaultButton, mergeStyleSets, Stack,
} from '@fluentui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import Store from '../shared/state/Store';
import Routing from '../shared/Routing';

export const DefaultNavOption = Routing.getTree({}).home.routes.administrationDashboard.routes.cloudUsageAllowances.path;

const styles = mergeStyleSets({
  menuItem: {
    textAlign: 'left',
    border: 'none !important',
    whiteSpace: 'nowrap',
    selectors: {
      ':hover': {
        outline: 'none !important',
        backgroundColor: '#e4e4e4',
      },

      span: {
        fontWeight: 'normal !important',
      },
    },
  },

  menuItemSelected: {
    backgroundColor: '#e4e4e4',
  },
});

export default () => {
  const [globalState] = Store.useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const routingTree = Routing.getTree(globalState).home.routes.administrationDashboard.routes;

  const menuItems = [
    {
      type: 'button',
      text: routingTree.cloudUsageAllowances.text,
      key: routingTree.cloudUsageAllowances.path,
      action: () => navigate(routingTree.cloudUsageAllowances.path),
    },
    {
      type: 'button',
      text: routingTree.licensesActivations.text,
      key: routingTree.licensesActivations.path,
      action: () => navigate(routingTree.licensesActivations.path),
    },
    {
      type: 'button',
      text: routingTree.endUsers.text,
      key: routingTree.endUsers.path,
      action: () => navigate(routingTree.endUsers.path),
    },
  ];

  const selectedMenuItem = location.pathname || DefaultNavOption;

  const renderedItems = menuItems.map(((menuItemData) => {
    if (menuItemData.type === 'button') {
      let className = styles.menuItem;
      if (menuItemData.key === selectedMenuItem) {
        className += ` ${styles.menuItemSelected}`;
      }

      return (
        <DefaultButton
          key={menuItemData.key}
          text={menuItemData.text}
          className={className}
          onClick={(event) => {
            menuItemData.action();
            event.target.closest('button').blur();
          }}
        />
      );
    }
    return <></>;
  }));

  return (
    <Stack vertical>
      {renderedItems}
    </Stack>
  );
};
